module.exports = __webpack_public_path__ + "static/media/influencer-1.149bf27f.png";